import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rastreador-management',
  templateUrl: './rastreador-management.component.html',
  styleUrls: ['./rastreador-management.component.scss']
})
export class RastreadorManagementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
